module.exports = __webpack_public_path__ + "static/media/zeebaars.261a1306.jpg";